export const config = {
  SERVICE_WORKER_PATH: "/service-worker/service-worker.js",
};
